import { IChaseActivity } from "../types/IChaseActivity";
import { IChase, IChaseAttributes } from "../types/IChase";
import { endpoint } from "../utils/endpoint";
import { axiosDelete, axiosGet, axiosPut } from "./axiosRequests";

export type IChasePayload = Partial<{
  aasm_state: IChaseAttributes["aasmState"];
  hot_at: IChaseAttributes["hotAt"];
  qualified_at: IChaseAttributes["qualifiedAt"];
  chase: {
    audit_type: string;
    audit_message: string;
  };
}>;

const chasesEndpoint = (id: string) => endpoint(`app/v1.0/chases/${id}`);

export const putChase = async (
  chaseId: string,
  payload: IChasePayload,
): Promise<IChase> => {
  const response = await axiosPut(chasesEndpoint(chaseId), payload);

  return response.data;
};

export const deleteChase = async (chaseId: string): Promise<void> => {
  await axiosDelete(chasesEndpoint(chaseId));
};

export const getChaseActivity = async (chaseId: string): Promise<IChaseActivity[]> => {
  const response = await axiosGet(`${chasesEndpoint(chaseId)}/chase_activities`);
  return response.data.data;
};
